/**
 * Vélemények section -- Swiper init.
 *
 * KRITIKUS: defer-rel betöltött scripteknél a böngésző a HTML-beli sorrendben
 * hajtja végre a scripteket. A `main.min.js` a `swiper-bundle.min.js` ELŐTT
 * fut le. Ekkor `document.readyState === 'interactive'` (NEM 'loading'),
 * és `window.Swiper` MÉG NEM elérhető. Ezért a readyState ellenőrzést úgy
 * kell írni, hogy bármi NEM 'complete' állapot esetén a DOMContentLoaded
 * eseményt várjuk (ami a defer scriptek lefutása UTÁN tűzelődik).
 *
 * `window.Swiper`-t használunk (NEM `typeof Swiper`), mert a Terser
 * a `typeof X === 'undefined'` mintát compile-time konstansnak veheti
 * és kioptimalizálhatja a függvény-törzset.
 */
(function () {
  'use strict';

  function init() {
    var SwiperLib = window.Swiper;
    if (!SwiperLib) { return; }

    var sliders = document.querySelectorAll('.velemenyek .velemenyek__swiper');
    if (!sliders.length) { return; }

    sliders.forEach(function (el) {
      var sectionEl  = el.closest('.velemenyek');
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      if (slideCount < 2) { return; }

      new SwiperLib(el, {
        loop: true,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        a11y: {
          prevSlideMessage: 'Előző vélemény',
          nextSlideMessage: 'Következő vélemény',
        },
        navigation: {
          prevEl: sectionEl ? sectionEl.querySelector('.velemenyek__nav-btn--prev') : null,
          nextEl: sectionEl ? sectionEl.querySelector('.velemenyek__nav-btn--next') : null,
          disabledClass: 'swiper-button-disabled',
        },
      });
    });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
